import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: flex-start;
`;

const ScrollableColumn = styled.div`
  width: 70%;
  overflow-y: auto;
  scrollbar-width: thin;
  -ms-overflow-style: auto;
`;

const FixedColumn = styled.div`
  width: 30%;
  margin-top: 1rem;
  overflow-y: auto;
  scrollbar-width: thin;
  -ms-overflow-style: auto;
`;

export const ColumnsWithScrolleableLayout = ({ leftContent, rightContent }) => {
  return (
    <Container>
      <ScrollableColumn>{leftContent}</ScrollableColumn>
      <FixedColumn>{rightContent}</FixedColumn>
    </Container>
  );
};
